export const userList = 'admins/user_list';

export const userCreation = 'admins/create_user';

export const userUpdate='admins/update_user';

export const updateConsultant='admins/update_consultant';

export const deleteConsultant = "admins/delete_consultant";

export const languagesList = 'language/list';

export const addLanguage='language/add_language';

export const servicesList = 'service/list';

export const addService='service/add_service';

export const DeleteService= 'admins/delete_service'

export const expertiseList = 'expertise/list';

export const addExpertise='expertise/add_expertise';

export const DeleteExpertise ='admins/delete_expertise';

export const rechargeList = 'recharge/all';

export const addRecharge='recharge/create';

export const credentialsList = 'application/list';

export const addCredentials='application/add_credential';

export const updateCredentials='application/update_credential_status'

export const  consultant= 'admins/consultant_list';

export const StatusConsultant='admins/approved';

export const consultant_Active='admins/permission';

export const AdminList='admins/list';

export const UpdateAdmin='admins/update_admin';

export  const recording='admins/consultant_pending_recordings';

export const uploadImage='upload_file/image'; 

export const updateRecordingStatus='admins/update_recording_status';

export const getConsultantBalance='admins/consultants_by_balance';

export const getBanks='admins/pending_bank_accounts'

export const approveBank='admins/update_bank_account_status' ;

export const postCredentials='consultant/fund_transfer';

export const Admin='admins/create';

export const subAdmin='admins/sub_admins_list';

export const sub_admin_create = 'admins/create_sub_admin';

export const subadminDelete='admins/delete_sub_admin';

export const adminDelete ='admins/delete_admin';

export const updateAdminStatus='admins/change_status';

export const updateConsultantAudio='voice_type/update_status';

export const PlanFetch='recharge/subscription_plans_list?name=Subscriptions';

export const otp='session/login';

export const rechargeDelete='recharge/delete';

export const getConsultantUserRecharge='admins/update_balance';

export const EditDetails = 'expertise/update';

export const EditServiceDetails = 'service/update';

export const updateLanguageDetail = 'language/update';

export const updateCredentialsDetail = 'application/update_credential';

export const userStatus = 'admins/permission';

export const DeleteApi = 'admins/delete_language';

export const updatePassword='admin/reset_password';

export const updateAdminPassword='admins/reset_admin_password';

export const userdelete = "user/delete_account";

export const dashboarduri = "analytics/recent_transactions";

export const statusuri = "analytics/overall";

export const ExcelFile = "admins/update_fund_details"

export const update_recharge = "recharge/update" ;

export const addSubscription = 'admins/add_subscription';

export const subscriptionList = 'subscriptions/list';

export const credentialDelete = 'application/delete_credential';

export const updateSubAdminPassword = 'admins/reset_sub_admin_password';

export const ResetAdminPassword = 'sub_admin/reset_password';

export const update_subadmin = 'admins/update_sub_admin';

export const platformAnalytics = 'analytics/platform_daily';
export const userAnalytics = 'analytics/user_daily';
export const consultantAnalytics = 'analytics/consultant_daily';